// Libraries
import React from 'react';

// Supermove
import {Icon, Space, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useHover} from '@supermove/hooks';
import {ProjectModel} from '@supermove/models';
import {colors} from '@supermove/styles';
import {ViewStyleProp} from '@supermove/styles/types';

// Shared
import IconButton from '@shared/design/components/IconButton';
import Text from '@shared/design/components/Text';

const Button = Styled.ButtonV2`
  flex-direction: row;
  max-width: 100%;
  align-items: center;
`;

const ProjectCommentsButton = ({
  project,
  style,
  handleViewComments,
}: {
  project: ProjectModel;
  style?: ViewStyleProp;
  handleViewComments: () => void;
}) => {
  const {ref, isHovered} = useHover();

  return (
    <Button style={style} onPress={handleViewComments} ref={ref}>
      <IconButton
        source={Icon.CommentDots}
        isDisplayOnly
        isSecondary
        isHoverDistinct
        isHovered={isHovered}
      />
      <Space width={6} />
      <Text.Body style={{color: isHovered ? colors.blue.hover : colors.gray.secondary}}>
        {project.officeThread ? project.officeThread.commentsCount : 0}
      </Text.Body>
    </Button>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectCommentsButton.fragment = gql`
  fragment ProjectCommentsButton on Project {
    id
    officeThread {
      id
      commentsCount
    }
  }
`;

export default ProjectCommentsButton;
